export enum clientTypes {
    LOADING = "LOADING",
    SELECTED_CLIENT = "SELECTED_CLIENT",
    GET_CLIENT_LIST = "GET_CLIENT_LIST",
}
  
export default clientTypes;